// eslint-disable-next-line no-restricted-imports -- this module IS the app theme
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

import './augmentation';
import { components } from './components';
import {
  accent,
  brand,
  breakpoints,
  heroGradient,
  palette,
  panelGradient,
  radius,
  roleTag,
  statusTag,
  surfaces,
} from './tokens';

/**
 * `cssVariables` emits `--mui-palette-*`, which src/styles/index.css maps onto
 * Tailwind's `--color-*`. That mapping is why `className="text-content-muted"`
 * and `sx={{ color: 'text.secondary' }}` render the identical colour.
 */
const baseTheme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'light',
    ...palette,
    brand,
    accent,
    statusTag,
    roleTag,
    panelGradient,
    heroGradient,
    background: surfaces.background,
    text: surfaces.text,
    divider: surfaces.divider,
  },
  breakpoints: { values: breakpoints },
  shape: { borderRadius: radius.md },
  spacing: 8,
  typography: {
    fontFamily: ['Inter Variable', 'Inter', 'system-ui', '-apple-system', 'sans-serif'].join(
      ',',
    ),
    // Small-screen sizes; responsiveFontSizes() scales up, never down.
    h1: { fontSize: '1.75rem', fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.02em' },
    h2: { fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.25, letterSpacing: '-0.015em' },
    h3: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.35 },
    h5: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.4 },
    body1: { fontSize: '1rem', lineHeight: 1.55 },
    body2: { fontSize: '0.875rem', lineHeight: 1.55 },
    overline: {
      fontSize: '0.6875rem',
      fontWeight: 650,
      lineHeight: 1.4,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
    },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components,
});

export const theme = responsiveFontSizes(baseTheme, { factor: 2.2 });

export { MIN_TOUCH_TARGET, breakpoints, radius } from './tokens';
